import React from 'react';

import CircularProgress from '@mui/material/CircularProgress';

import { useStyles } from './LoadingPageStyle';

function LoadingPageDisplay() {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <div className={styles.loaderContainer}>
        <CircularProgress className={styles.progress} size={200} thickness={2} color="primary" />
        <CircularProgress className={styles.progress} size={170} thickness={2} color="secondary" />
        <CircularProgress className={styles.progress} size={140} thickness={2} color="primary" />
        <CircularProgress className={styles.progress} size={110} thickness={2} color="secondary" />
        <CircularProgress className={styles.progress} size={90} thickness={2} color="primary" />
      </div>
    </div>
  );
}

export default LoadingPageDisplay;
